/* eslint-disable max-len */
/* eslint-disable vue/max-len */

import { create } from '@bufbuild/protobuf';

import * as pbm from '@/grpc-gen/giftcard_product_pb';
import * as pbs from '@/grpc-gen/giftcards_service_pb';
import Currency from './currency';

export interface GiftcardProductMapping {
}

export default class GiftcardProduct {
  id: number = 0;

  code?: string;

  title?: string;

  description?: string;

  bgUrl?: string;

  serviceId?: number;

  locale?: string;

  enabled?: boolean;

  bgColor?: string;

  expireMonths?: number;

  showLogo?: boolean;

  footerText?: string;

  amounts: number[] = [];

  currency?: string;

  paymentAccountConfigured?: boolean;

  paymentAccountActive?: boolean;

  static fromGrpcResponse(r: pbs.GiftcardsProductResponse, m?: GiftcardProductMapping): GiftcardProduct {
    return GiftcardProduct.fromGrpcModel(r.product, m);
  }

  static fromGrpcModel(o?: pbm.GiftcardProduct, m?: GiftcardProductMapping): GiftcardProduct {
    const p = new GiftcardProduct();

    p.id = Number(o?.id ?? 0);
    p.code = o?.code || undefined;
    p.title = o?.title || undefined;
    p.description = o?.description || undefined;
    p.bgUrl = o?.backgroundImageUrl || undefined;
    p.serviceId = Number(o?.serviceId ?? 0) || undefined;
    p.locale = o?.locale || undefined;
    p.enabled = o?.isActive;
    p.bgColor = o?.color || undefined;
    p.expireMonths = o?.expirePeriodInMonths || undefined;
    p.showLogo = o?.showLogo;
    p.footerText = o?.footerText || undefined;
    p.amounts = (o?.prices ?? []).map((x) => Number(x ?? 0));
    p.currency = o?.currency || undefined;
    p.paymentAccountConfigured = o?.paymentAccountConfigured;
    p.paymentAccountActive = o?.paymentAccountActive;

    return p;
  }

  toGrpcModel(): pbm.GiftcardProduct {
    return create(pbm.GiftcardProductSchema, {
      id: BigInt(this.id),
      code: this.code ?? '',
      title: this.title ?? '',
      description: this.description ?? '',
      backgroundImageUrl: this.bgUrl ?? '',
      serviceId: BigInt(this.serviceId ?? 0),
      locale: this.locale ?? '',
      isActive: this.enabled ?? false,
      color: this.bgColor ?? '',
      expirePeriodInMonths: this.expireMonths ?? 0,
      showLogo: this.showLogo ?? false,
      footerText: this.footerText ?? '',
      prices: (this.amounts ?? []).map((x) => BigInt(x)),
      fees: [],
      currency: this.currency ?? '',
      paymentAccountConfigured: this.paymentAccountConfigured ?? false,
      paymentAccountActive: this.paymentAccountActive ?? false,
    });
  }

  clone(): GiftcardProduct {
    const copy = new GiftcardProduct();
    Object.assign(copy, this);
    copy.amounts = Array.from(this.amounts);
    return copy;
  }
}
